var _radialGradient, _radialGradient2, _linearGradient, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 265,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 265",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: -14920.2256,
    cy: -8274.0713,
    fx: -14928.1611,
    gradientTransform: "matrix(.7398 .02920152 -.0486692 1.0902 10886.5264 9537.6963)",
    gradientUnits: "userSpaceOnUse",
    r: 124.382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e0255a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#cc2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 167.60860234,
    cy: 40.87595351,
    gradientUnits: "userSpaceOnUse",
    r: 261.33778398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ccda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0083ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#007af9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0060e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#005fe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2639ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#401e84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a1475"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 145.2425,
    x2: 93.8365,
    y1: 195.7857,
    y2: 27.6288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000f43",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#001962",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002079",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -9132.6758,
    cy: -6696.7002,
    gradientTransform: "matrix(1.1875 .1168 -.1168 1.1875 10322.1836 9194.8447)",
    gradientUnits: "userSpaceOnUse",
    r: 73.6256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -9139.3379,
    cy: -6767.2969,
    gradientTransform: "matrix(1.1875 .1168 -.1168 1.1875 10322.1836 9194.8447)",
    gradientUnits: "userSpaceOnUse",
    r: 122.9475
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ffaf0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ff7a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff4e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff2c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ff1434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ff0538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0039"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -9121.9473,
    cy: -6653.3262,
    gradientTransform: "matrix(1.1875 .1168 -.1168 1.1875 10322.1836 9194.8447)",
    gradientUnits: "userSpaceOnUse",
    r: 112.8177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#620700"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 192.0477316,
    cy: 105.806928,
    fx: 199.56014078,
    fy: 102.09379636,
    gradientUnits: "userSpaceOnUse",
    r: 210.0363584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f92433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#e91c45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#cf0e62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b5007f"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 180.0043401,
    cy: 8.39869266,
    gradientUnits: "userSpaceOnUse",
    r: 239.37833332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ffba00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ff9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ff6711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ff4a1d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(1.22 .12 -.12 1.22 10634.7598 9460)",
    gradientUnits: "userSpaceOnUse",
    x1: -9348.6621,
    x2: -9266.2168,
    y1: -6754.1943,
    y2: -6775.209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42482",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff272d",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ff2c2c",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ff7a1a",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ffb20d",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffd605",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe302"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "matrix(.99 .1 -.1 .99 -175.62 1176.2098)",
    gradientUnits: "userSpaceOnUse",
    x1: 103.0922,
    x2: 88.439,
    y1: -1126.7808,
    y2: -1164.3336
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#891551",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(.99 .1 -.1 .99 303.51 -384.2)",
    gradientUnits: "userSpaceOnUse",
    x1: -193.2793,
    x2: -168.0087,
    y1: 534.1769,
    y2: 562.8766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#891551",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff272d",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff272d",
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(.99 .1 -.1 .99 303.51 -384.2)",
    gradientUnits: "userSpaceOnUse",
    x1: -144.6839,
    x2: -144.6651,
    y1: 583.6765,
    y2: 563.5964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c42482",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c42482",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#c42482",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c42482",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c42482",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c42482",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c42482",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 166.5909,
    x2: 248.6675,
    y1: 9.7137,
    y2: 193.2461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff14f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffee4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ffe643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ffd834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ffc41e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ffab02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffa900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9100"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 182.8878,
    x2: 144.0111,
    y1: 115.2735,
    y2: 219.6616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ff8e00",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ff8e00",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ff8e00",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ff8e00",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff8e00",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ff8e00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ff8e00",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ff8e00",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ff8e00",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ff8e00",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8e00",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m206.8 24.6c-6.4 7.5-9.4 24.3-2.9 41.4s16.5 13.4 22.7 30.8c8.2 23 4.4 53.9 4.4 53.9s9.9 28.6 16.8-1.8c15.3-57.1-41-110.2-41-124.3z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m128.4 261.7c65.9 0 119.2-53.6 119.2-119.8s-53.4-119.7-119.2-119.7-119.1 53.6-119.1 119.7c-.1 66.2 53.3 119.8 119.1 119.8z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m217.7 215.8c-2.6 1.8-5.3 3.4-8.1 4.9 3.7-5.5 7.2-11.1 10.3-16.9 2.5-2.8 4.9-5.5 6.8-8.5.9-1.5 2-3.2 3.1-5.3 6.7-12.1 14.1-31.6 14.3-51.6v-1.5c0-5-.5-10.1-1.5-15 .1.4.1.8.2 1.2-.1-.3-.1-.6-.2-.9.1.5.2 1.1.3 1.6 1.4 11.6.4 22.9-4.5 31.3-.1.1-.2.2-.2.4 2.5-12.7 3.4-26.7.6-40.7 0 0-1.1-6.8-9.5-27.5-4.8-11.9-13.4-21.7-20.9-28.8-6.6-8.2-12.7-13.7-16-17.2-6.9-7.3-9.8-12.8-11-16.3-1-.5-14.3-13.4-15.3-13.9-5.8 9-23.9 37-15.3 63.1 3.9 11.9 13.8 24.2 24.2 31.1.5.5 6.2 6.7 8.9 20.7 2.8 14.5 1.3 25.7-4.4 42.4-6.8 14.6-24.2 29.1-40.5 30.6-34.8 3.2-47.6-17.5-47.6-17.5 12.4 5 26.2 3.9 34.6-1.2 8.4-5.2 13.5-9.1 17.7-7.6 4.1 1.5 7.3-2.9 4.4-7.5-4.6-7.1-13-10.7-21.3-9.3-8.4 1.4-16.2 8.1-27.2 1.6-.7-.4-1.4-.9-2.1-1.4s2.4.7 1.6.2c-2.1-1.2-6-3.7-6.9-4.6-.2-.2 1.7.6 1.5.4-10.3-8.5-9-14.3-8.7-17.9.3-2.9 2.1-6.6 5.3-8.1 1.5.8 2.5 1.5 2.5 1.5s-.7-1.3-1-2c.1-.1.2 0 .4-.1 1.3.6 4 2.2 5.5 3.1 1.9 1.3 2.5 2.5 2.5 2.5s.5-.3.1-1.4c-.1-.5-.7-2-2.6-3.5h.1c1.1.6 2.2 1.4 3.2 2.2.5-1.9 1.5-3.9 1.3-7.5-.1-2.5-.1-3.2-.5-4.2-.4-.8.2-1.2.9-.3-.1-.7-.3-1.4-.6-2v-.1c.9-3 18.3-10.9 19.6-11.8 2.1-1.5 3.8-3.4 5.1-5.6 1-1.5 1.7-3.7 1.9-7 .1-2.4-1-4-18.7-5.8-4.8-.5-7.7-4-9.3-7.2-.3-.7-.6-1.3-.9-2s-.5-1.5-.7-2.3c2.9-8.3 7.7-15.3 14.9-20.6.4-.4-1.6.1-1.2-.3.5-.4 3.4-1.6 4-1.9.7-.3-2.9-1.9-6.1-1.5s-3.9.8-5.7 1.5c.7-.7 3-1.7 2.5-1.6-3.5.5-7.8 2.6-11.5 4.9 0-.4.1-.8.2-1.2-1.7.7-6 3.7-7.2 6.2.1-.5.1-1 .1-1.5-1.3 1.1-2.5 2.3-3.5 3.7l-.6.2c-10-4-18.9-4.3-26.3-2.5-1.6-1.6-2.4-.4-6.2-8.6-.3-.5.2.5 0 0-.6-1.6.4 2.1 0 0-6.2 5-14.4 10.6-18.4 14.5 0 .2 4.6-1.3 0 0-1.6.5-1.5 1.4-1.7 10.1-.1.7 0 1.4-.1 2-3.2 4-5.3 7.4-6.1 9.2-4.1 7-8.6 18-12.9 35.3 1.9-4.7 4.2-9.2 6.9-13.5-3.6 9.2-7.1 23.7-7.8 45.9.9-4.6 2-9.1 3.4-13.6-.9 18.5 2.3 36.9 9.3 54 2.5 6.1 6.6 15.4 13.7 25.6 22.2 23.3 53.4 37.8 88 37.8 36.1 0 68.6-15.8 90.9-40.9z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m190.9 232.7c43.7-5.1 63.1-50.1 38.2-51-22.4-.7-58.9 53.4-38.2 51z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m232.3 172.5c30.1-17.5 22.2-55.3 22.2-55.3s-11.6 13.5-19.5 35c-7.7 21.3-20.8 30.9-2.7 20.3z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m136.8 255.1c42 13.4 78-19.7 55.8-30.7-20.2-9.9-75.7 24.4-55.8 30.7z",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m235.5 188.6c1-1.4 2.4-6 3.6-8.1 7.4-12 7.5-21.5 7.5-21.7 4.5-22.3 4.1-31.5 1.3-48.3-2.2-13.6-11.9-33.1-20.3-42.4-8.6-9.7-2.6-6.5-10.9-13.6-7.3-8.1-14.5-16.2-18.3-19.4-28-23.4-27.4-28.4-26.8-29.2-.1.1-.2.2-.4.4-.3-1.3-.6-2.4-.6-2.4s-15.4 15.2-18.6 40.7c-2.1 16.6 4.1 34 13.2 45.1 4.7 5.8 10 11 15.8 15.6 6.8 9.8 10.6 21.9 10.6 34.9 0 32.6-26.4 58.9-59 58.9-4.4 0-8.9-.5-13.2-1.5-15.4-2.9-24.2-10.7-28.7-16-2.5-3-3.6-5.2-3.6-5.2 13.8 4.9 29 3.9 38.3-1.2 9.3-5.2 15-9 19.6-7.5 4.5 1.5 8.1-2.9 4.9-7.4s-11.4-11-23.6-9.2c-9.3 1.4-17.9 8-30.1 1.6-.8-.4-1.6-.9-2.3-1.3-.8-.5 2.6.7 1.8.2-2.4-1.2-6.6-3.7-7.7-4.6-.2-.2 1.8.6 1.7.4-11.4-8.4-10-14.1-9.7-17.7.3-2.9 2.4-6.5 5.9-8 1.7.8 2.7 1.5 2.7 1.5s-.7-1.3-1.1-2c.1-.1.3 0 .4-.1 1.4.6 4.5 2.1 6.1 3.1 2.1 1.3 2.8 2.5 2.8 2.5s.6-.3.1-1.4c-.2-.5-.8-2-2.9-3.5h.1c1.2.6 2.4 1.4 3.5 2.2.6-1.9 1.6-3.9 1.4-7.5-.1-2.5-.1-3.2-.6-4.1-.4-.8.2-1.2 1-.3-.1-.7-.4-1.3-.7-2v-.1c1-3 20.3-10.8 21.7-11.7 2.3-1.4 4.2-3.3 5.7-5.5 1.1-1.5 1.9-3.7 2.1-7 .1-1.5-.4-2.6-5.5-3.8-3.1-.7-7.8-1.3-15.2-2-5.3-.5-8.5-3.9-10.3-7.1-.3-.7-.7-1.3-1-1.9-.3-.7-.6-1.5-.8-2.2 3.2-8.4 9-15.5 16.5-20.4.4-.4-1.7.1-1.3-.3.5-.4 3.8-1.6 4.4-1.9.8-.3-3.2-1.8-6.8-1.5-3.6.4-4.3.7-6.3 1.5.8-.7 3.3-1.6 2.7-1.6-3.6.4-8.4 2.4-12.5 4.7 0-.4.1-.8.2-1.2-1.9.7-6.6 3.7-8 6.2.1-.5.1-1 .1-1.4-1.4 1.1-2.8 2.3-3.9 3.7l-.1.1c-11.1-4-20.9-4.3-29.1-2.5-1.8-1.6-4.7-4.1-8.8-12.2-.3-.5-.4 1-.6.5-1.6-3.7-2.6-9.8-2.4-14 0 0-3.3 1.5-6 7.8-.5 1.1-.8 1.8-1.2 2.4-.2.2.3-2.1.3-1.9-.5.8-1.7 1.9-2.2 3.4-.4 1.1-.9 1.7-1.2 3l-.1.1c0-.4.1-1.6 0-1.4-1.3 2.6-2.4 5.3-3.3 8-1.5 4.8-3.2 11.4-3.5 20-.1.6 0 1.4-.1 2-3.5 4-5.9 7.4-6.8 9.1-4.5 7-9.5 17.8-14.3 35 2.1-4.7 4.7-9.2 7.7-13.4-4 9.1-7.9 23.5-8.7 45.5 1-4.6 2.2-9.1 3.7-13.5-.7 14.7 1 33 10.3 53.6 5.5 12.1 18.2 36.7 49.3 55.9s10.6 7.9 28.7 13.8c1.3.5 2.7 1 4.1 1.4-.4-.2-.9-.4-1.3-.5 12.1 3.6 24.6 5.5 37.3 5.5 47 0 60.9-18.9 60.9-18.9l-.1.1c.7-.6 1.3-1.3 1.9-1.9-7.4 7-24.4 7.5-30.7 7 10.8-3.2 17.9-5.9 31.7-11.1 1.6-.6 3.3-1.3 5-2.1l.5-.3c.3-.2.7-.3 1-.5 6.7-3.2 13.1-7.1 18.9-11.8 13.9-11.1 16.9-21.9 18.5-29-.2.7-.9 2.3-1.4 3.3-3.6 7.6-11.5 12.4-20.1 16.4 4.1-5.4 7.9-11 11.4-16.8 2.8-2.8 3.6-7.2 5.8-10.1z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m218.6 215.1c5.7-6.2 10.7-13.4 14.6-21.5 9.9-20.8 25.2-55.5 13.2-91.6-9.5-28.6-22.6-44.2-39.2-59.5-27-24.8-34.5-35.9-34.5-42.5 0 0-31.2 34.7-17.7 71s41.2 34.9 59.5 72.7c21.6 44.5-17.4 93.1-49.7 106.7 2-.4 71.7-16.2 75.4-56.1-.2.7-1.8 11.8-21.6 20.8z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m128.2 85.8c.1-2.4-1.1-3.9-20.6-5.8-8-.7-11.1-8.1-12-11.3-2.8 7.4-4 15.2-3.4 24.6.4 6.2 4.6 12.8 6.5 16.6 0 0 .4-.6.6-.8 3.7-3.9 19.3-9.8 20.8-10.6 1.7-1 7.9-5.5 8.1-12.7z",
    fill: "url(#i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m42.5 42c-.3-.5-.4 1-.6.5-1.6-3.7-2.6-9.7-2.3-14 0 0-3.3 1.5-6 7.8-.5 1.1-.8 1.8-1.2 2.4-.2.2.3-2.1.3-1.9-.5.8-1.7 1.9-2.2 3.3-.4 1.1-.9 1.8-1.2 3.2-.1.4.1-1.7 0-1.4-6.4 12.3-7.6 30.9-6.9 30.1 13.6-14.5 29.1-17.9 29.1-17.9-1.9-1.2-5.5-4.8-9-12.1z",
    fill: "url(#j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m93.9 193.4c-18.7-8-40-19.3-39.2-44.9 1.1-33.7 31.5-27.1 31.5-27.1-1.1.3-4.2 2.5-5.3 4.8-1.1 2.9-3.2 9.5 3.1 16.4 10 10.8-20.5 25.6 26.5 53.6 1.2.6-11-.4-16.6-2.8z",
    fill: "url(#k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m87.3 176.6c13.3 4.6 28.7 3.8 38-1.3 6.2-3.5 14.2-9 19-7.6-4.2-1.7-7.4-2.5-11.3-2.6-.7 0-1.4 0-2.1-.1-1.4 0-2.8.1-4.2.2-2.4.2-5 1.7-7.4 1.5-.1 0 2.3-1 2.1-1-1.3.3-2.7.3-4.1.5-.9.1-1.7.2-2.7.3-27.7 2.3-51-15-51-15-2 6.6 8.9 19.9 23.7 25.1z",
    fill: "url(#l)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m218.5 215.3c28-27.5 42.1-60.8 36.1-98.3 0 0 2.4 19.2-6.7 38.8 4.4-19.2 4.9-43-6.7-67.7-15.4-32.9-40.8-50.3-50.5-57.5-14.7-11-20.8-22.1-20.9-24.4-4.4 9-17.7 39.8-1.4 66.3 15.2 24.9 39.2 32.2 55.9 55 31 42.1-5.8 87.8-5.8 87.8z",
    fill: "url(#m)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m214.5 143.8c-9.8-20.2-22-29-33.5-38.5 1.3 1.9 1.7 2.5 2.4 3.8 10.2 10.8 25.1 37.2 14.3 70.4-20.5 62.4-102.3 33-110.9 24.8 3.5 36.1 63.9 53.4 103.3 30 22.3-21.4 40.4-57.4 24.4-90.5z",
    fill: "url(#n)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFirefox);
export default __webpack_public_path__ + "static/media/icon_firefox.b5319decd694447f06919edf08cad8d7.svg";
export { ForwardRef as ReactComponent };